import "../../newProviderAppCSS/login.css";
import React, { useEffect, useRef } from "react";

const OTP_LENGTH = 6;
const FOCUS_RETRY_DELAY_MS = 120;

const sanitizeOtp = (value) => (value || "").replace(/\D/g, "").slice(0, OTP_LENGTH);

function OTPVerify({ otp = "", handleOTP = () => {} }) {
   const inputRef = useRef(null);

   useEffect(() => {
      const rafId = window.requestAnimationFrame(() => {
         inputRef.current?.focus();
      });
      const timeoutId = window.setTimeout(() => {
         inputRef.current?.focus();
      }, FOCUS_RETRY_DELAY_MS);

      return () => {
         window.cancelAnimationFrame(rafId);
         window.clearTimeout(timeoutId);
      };
   }, []);

   const otpValue = sanitizeOtp(otp);
   const activeIndex = Math.min(otpValue.length, OTP_LENGTH - 1);

   const handleChange = (event) => {
      const nextValue = sanitizeOtp(event.target.value);
      handleOTP(nextValue);
   };

   const handlePaste = (event) => {
      const pastedValue = event.clipboardData?.getData("text") || "";
      const nextValue = sanitizeOtp(pastedValue);
      if (!nextValue) return;

      event.preventDefault();
      handleOTP(nextValue);
   };

   return (
      <div
         className="otp-center"
         style={{ position: "relative", cursor: "text" }}
         onClick={() => inputRef.current?.focus()}
      >
         <input
            ref={inputRef}
            autoFocus
            type="tel"
            inputMode="numeric"
            pattern="[0-9]*"
            maxLength={OTP_LENGTH}
            autoComplete="one-time-code"
            enterKeyHint="done"
            aria-label="Enter verification code"
            autoCorrect="off"
            autoCapitalize="off"
            spellCheck={false}
            value={otpValue}
            onChange={handleChange}
            onPaste={handlePaste}
            style={{
               position: "absolute",
               inset: 0,
               zIndex: 2,
               opacity: 0,
               color: "transparent",
               caretColor: "transparent",
               width: "100%",
               height: "100%",
               fontSize: "16px",
            }}
         />

         <div className="new-otp-container">
            {Array.from({ length: OTP_LENGTH }).map((_, index) => (
               <div key={index} className="new-otp-input-custom flex-center">
                  {otpValue[index] || ""}
                  {index === activeIndex && otpValue.length < OTP_LENGTH ? <span className="otp-blink-caret">|</span> : null}
               </div>
            ))}
         </div>
      </div>
   );
}

export default OTPVerify;
